import React from 'react';
import { ArrowLeft } from 'lucide-react';

/**
 * Sticky header for full-screen mobile flows (forms, wizard) where the
 * bottom nav is hidden. Bleeds to the screen edges inside <main>'s padding.
 */
function MobilePageHeader({ title, subtitle, onBack, right }) {
  return (
    <div className="md:hidden sticky top-0 z-30 -mx-4 -mt-4 mb-4 bg-white/95 backdrop-blur border-b border-gray-200 pt-safe">
      <div className="flex items-center gap-2 px-2 h-12">
        {onBack && (
          <button
            type="button"
            onClick={onBack}
            className="p-2 rounded-full text-gray-700 active:bg-gray-100"
            aria-label="Back"
          >
            <ArrowLeft className="w-6 h-6" />
          </button>
        )}
        <div className="flex-1 min-w-0 px-1">
          <h1 className="text-base font-semibold text-gray-900 truncate">{title}</h1>
          {subtitle && <p className="text-xs text-gray-500 truncate">{subtitle}</p>}
        </div>
        {right}
      </div>
    </div>
  );
}

export default MobilePageHeader;
